module.exports = "/images/london-12.jpg";